import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface IFiatDepositsState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface IFiatDepositsAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: IFiatDepositsState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IFiatDepositsState, action: IFiatDepositsAction): IFiatDepositsState => {
  return {
    ...state,
    isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IFiatDepositsState, action: IFiatDepositsAction): IFiatDepositsState => {
  return {
    ...state,
    isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IFiatDepositsState, action: IFiatDepositsAction): IFiatDepositsState => {
  return {
    ...state,
    jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: IFiatDepositsState, action: IFiatDepositsAction) => IFiatDepositsState } = {
  // Fiat Deposits reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_DEPOSITS)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_DEPOSITS)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_DEPOSITS)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const fiatDepositsReducer = (state = INITIAL_STATE, action: IFiatDepositsAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
    return reducerMap[action.type](state, action);
  } else {
    return state;
  }
}

export default fiatDepositsReducer;
